<template>
  <div class="calendar">
    <Input
      v-model="label"
      :placeholder="`请选择${fieldModel.label}`"
      :disabled="fieldModel.disabled"
      @on-focus="show = true"
    />
    <Drawer v-model="show" width="90" :transfer="false" :closable="false">
      <div class="top">
        <div ref="calendarDOM"></div>
      </div>
      <div class="center" ref="center">
        <workteam-process
          :company-id="selected.companyId"
          :begin-date="startDate"
          :end-date="endDate"
          :date="this.fieldModel.date"
          @on-click-row="clickProcessRow"
        ></workteam-process>
      </div>

      <div class="footer-bar">
        <div class="desc">
          <span>{{ this.selected.companyName }}</span>
          <span>{{ this.selected.preCheckInDate }}</span>
        </div>
        <Button @click="onOk" type="primary">确定</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import zhCnLocale from '@fullcalendar/core/locales/zh-cn'
export default {
  name: 'DynamicFormCalendar',
  props: ['value', 'fieldModel'],
  data() {
    return {
      toolTip: {
        show: false,
        el: null,
      },
      show: false,
      label: '',
      calendar: null,
      selected: {
        companyName: '',
        companyId: '',
        preCheckInDate: '',
      },
    }
  },
  computed: {
    startDate() {
      if (this.fieldModel.event.list.length > 0) {
        return this.fieldModel.event.list[0].date
      } else {
        return ''
      }
    },
    endDate() {
      if (this.fieldModel.event.list.length > 0) {
        return this.fieldModel.event.list[this.fieldModel.event.list.length - 1]
          .date
      } else {
        return ''
      }
    },
  },
  watch: {
    show(newValue) {
      if (newValue && !this.calendar) {
        this.$nextTick(() => {
          this.init()
        })
      }
    },
  },
  methods: {
    init() {
      this.calendar = new Calendar(this.$refs.calendarDOM, {
        height: '100%',
        plugins: [dayGridPlugin],
        initialView: 'dayGridMonth',
        initialDate: this.fieldModel.date,
        locale: zhCnLocale,
        dayCellContent: (arg) => {
          const dayCellHeader = document.createElement('div')
          dayCellHeader.classList.add('day-cell-header')
          const dayText = document.createElement('div')
          dayText.classList.add('day-text')
          dayText.innerText = arg.dayNumberText
          dayCellHeader.append(dayText)
          if (!arg.isPast) {
            const select = document.createElement('select')
            select.classList.add('day-cell-header-select')
            select.innerHTML = '<option value="-1:请选择">请选择</option>'
            this.$store.state.selectOption.companies.forEach((item) => {
              const option = document.createElement('option')
              option.innerText = item.label
              option.value = item.value + ':' + item.label
              select.append(option)
            })
            select.onchange = (e) => {
              const events = this.calendar.getEvents()
              events.forEach((event) => {
                if (event.backgroundColor) {
                  event.setProp('backgroundColor', '')
                  event.setProp('borderColor', '')
                }
              })
              const selected = e.target.value.split(':')
              this.selected.companyName = selected[1]
              this.selected.companyId = selected[0]
            }
            dayCellHeader.append(select)
          }

          return {
            domNodes: [dayCellHeader],
          }
        },
        eventDidMount: function (info) {
          info.el.setAttribute('title', info.event.title)
        },
        eventClick: (info) => {
          const events = this.calendar.getEvents()
          events.forEach((event) => {
            if (event.backgroundColor) {
              event.setProp('backgroundColor', '')
              event.setProp('borderColor', '')
            }
          })
          info.event.setProp('backgroundColor', '#19be6b')
          this.selected.companyName = info.event.extendedProps.companyName
          this.selected.companyId = info.event.extendedProps.companyId
        },
      })
      this.createEvents()
      this.calendar.render()
    },
    createEvents() {
      this.fieldModel.event.list.forEach((item, index) => {
        item.companyList.forEach((_item, _index) => {
          this.calendar.addEvent({
            id: `${index}-${_index}`,
            title: `${_item.companyName} 空闲${_item.freeCount}`,
            start: item.date,
            end: item.date,
            extendedProps: {
              companyName: _item.companyName,
              companyId: _item.companyId,
            },
          })
        })
      })
    },
    clickProcessRow(date) {
      this.selected.preCheckInDate = date
    },
    onOk() {
      this.label = this.selected.companyName
      if (this.fieldModel.set) {
        this.$emit('input', this.fieldModel.set(this.selected))
      }
      this.show = false
    },
  },
}
</script>
<style lang="stylus" scoped>
.calendar
  width 100%
  display flex

  >>>.day-cell-header
    display flex
    visibility visible
    position relative
    align-content center
    justify-content space-between
    width 100%

    .day-cell-header-select
      width 0
      flex auto

    .day-text
      margin 0 10px 0 5px

  .calendar-event--selected
    background #27639e
    border 1px solid #27639e

  >>>.ivu-drawer-body
    padding-bottom 0
    display flex
    flex-flow column

    .top
      flex 0 0 40%
      height 0

    .center
      flex auto
      height 0
      margin-top 10px

  .footer-bar
    display flex
    justify-content flex-end
    align-items center
    flex 0 0 60px
    height 0
    background #fff

    .desc
      display flex
      text-align right
      flex-flow column
      margin-right 20px
      font-weight bold
</style>
